// src/web/CreditsPage.jsx

import { useTranslation } from "react-i18next";
import PageTracker from "../../components/tracking/PageTracker";
import ScrollTracker from "../../components/tracking/ScrollTracker";
import AVIcon from '../../components/icons/AllVoicedIcons';

export default function CreditsAndCitations() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <div className="credits-page">
      <PageTracker pageName="CreditsAndCitations" />
      <div className="credits-content">
        <h1>{t("credits_and_citations", "Credits & Citations")}</h1>

        {/* ──────────────── */}
        {/* 📘 SCIENTIFIC CREDITS */}
        {/* ──────────────── */}
        <h2>{t("scientific_instruments_and_data", "Scientific Instruments & Data Sources")}</h2>
        <p>{t("we_acknowledge_scientific_sources", "We gratefully acknowledge the researchers and organizations whose work supports All-Voiced tools and databases.")}</p>

        <div className="credits-citations">
          <h3>CAPE-V ({t('original_instrument')})</h3>
           Kempster, G. B., Gerratt, B. R., Verdolini Abbott, K., Barkmeier-Kraemer, J., & Hillman, R. E. (2009). Consensus auditory-perceptual evaluation of voice: Development of a standardized clinical protocol. <em>American Journal of Speech-Language Pathology, 18</em>(2), 124–132. <a href="https://doi.org/10.1044/1058-0360(2008/08-0017)" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/1058-0360(2008/08-0017)</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2009). {t('reprinted_with_permission')}.<br />
          <h3>CAPE-V ({t('adaptations')})</h3>
           Behlau, M., Rocha, B., Englert, M., & Madazio, G. (2022). Validation of the Brazilian Portuguese CAPE-V Instrument-Br CAPE-V for auditory-perceptual analysis. <em>Journal of Voice, 36</em>(4), 586.e15–586.e20. <a href="https://doi.org/10.1016/j.jvoice.2020.07.007" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2020.07.007</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2022). {t('reprinted_with_permission')}.<br /><br />
           Calaf, N., & Garcia-Quintana, D. (2024). Development and validation of the bilingual Catalan/Spanish cross-cultural adaptation of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 67</em>(4), 1072–1089. <a href="https://doi.org/10.1044/2024_JSLHR-23-00536" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2024_JSLHR-23-00536</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2024). {t('reprinted_with_permission')}.<br /><br />
           Gunjawate, D. R., Ravi, R., & Bhagavan, S. (2020). Reliability and validity of the Kannada version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 63</em>(2), 385–392. <a href="https://doi.org/10.1044/2021_JSLHR-21-00269" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2021_JSLHR-21-00269</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2020). {t('reprinted_with_permission')}.<br /><br />
           Kondo, K., Mizuta, M., Kawai, Y., Sogami, T., Fujimura, S., Kojima, T., ... & Haji, T. (2021). Development and validation of the Japanese version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Journal of Speech, Language, and Hearing Research, 64</em>(12), 4754–4761. <a href="https://doi.org/10.1044/2021_JSLHR-21-00269" target="_blank" rel="noopener noreferrer">https://doi.org/10.1044/2021_JSLHR-21-00269</a>. © <a href="https://www.asha.org/" target="_blank" rel="noopener noreferrer">ASHA</a> (2021). {t('reprinted_with_permission')}.<br /><br />
           {/*Salary Majd, N., Khoddami, S. M., Drinnan, M., Kamali, M., Amiri-Shavaki, Y., & Fallahian, N. (2014). Validity and rater reliability of Persian version of the Consensus Auditory-Perceptual Evaluation of Voice. <em>Audiology, 23</em>(3), 65–74. © Audiology (2014). {t('reprinted_with_permission')}.<br /><br />*/}
           Mossadeq, N. M., Khairuddin, K. A. M., & Zakaria, M. N. (2022). Cross-cultural adaptation of the Consensus Auditory-Perceptual Evaluation of Voice (CAPE-V) into Malay: A validity study. <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2022.05.018" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2022.05.018</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2022). {t('reprinted_with_permission')}.<br /><br />
           Pommée, T., Mbagira, D., & Morsomme, D. (2024). French-language adaptation of the Consensus Auditory-Perceptual Evaluation of Voice (CAPE-V). <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2024.03.011" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2024.03.011</a>. © <a href="https://www.elsevier.com/" target="_blank" rel="noopener noreferrer">Elsevier</a> (2024). {t('reprinted_with_permission')}.<br /><br />
           Pommée, T., Defoy, L., & Verduyckt, I. (2025). From practice to protocol: The CAPE-VFQ by and for Quebec French SLPs. <em>Clinical Linguistics & Phonetics</em>, 1–12. <a href="https://doi.org/10.1080/02699206.2025.2456214" target="_blank" rel="noopener noreferrer">https://doi.org/10.1080/02699206.2025.2456214</a>. © <a href="https://www.tandfonline.com/" target="_blank" rel="noopener noreferrer">Taylor & Francis</a> (2025). {t('reprinted_with_permission')}.<br />

          <h3>CAPE-Vr ({t('original_instrument')})</h3>
          Kempster, G. B., Nagle, K. F., & Solomon, N. P. (2025). Development and rationale for the Consensus Auditory-Perceptual Evaluation of Voice – Revised (CAPE-Vr). <em>Journal of Voice</em>. <a href="https://doi.org/10.1016/j.jvoice.2025.01.022" target="_blank" rel="noopener noreferrer">https://doi.org/10.1016/j.jvoice.2025.01.022</a>. {t('creative_commons_license_notice')} <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">https://creativecommons.org/licenses/by/4.0/</a>.

          <h3>PVQD</h3>
          Walden, P. R. (2022). Perceptual Voice Qualities Database (PVQD) <em>(Version 4)</em> [Data set]. <em>Mendeley Data</em>. <a href="https://doi.org/10.17632/9dz247gnyb.2" target="_blank" rel="noopener noreferrer">https://doi.org/10.17632/9dz247gnyb.2</a>.
       </div>


        {/* ──────────────── */}
        {/* 📘 OPEN-SOURCE CREDITS */}
        {/* ──────────────── */}

        <h2>{t('open_source_libraries', 'Open Source Libraries & Licenses')}</h2>
        <p>{t('we_acknowledge_open_source', 'This project makes use of open source libraries and frameworks. We acknowledge and thank the developers of these tools:')}</p>

        <ul className="open-source-list">
          <li><strong>Backend:</strong> Express, Mongoose, Nodemailer, Bcrypt, Socket.io, Axios, Joi, Pusher</li>
          <li><strong>Frontend:</strong> React, React Router, React i18next, Chart.js, D3, Recharts, React-PDF, JsPDF, PdfMake, React Icons, React Simple Maps, React Datepicker, Socket.io-client</li>
          <li><strong>Development tools:</strong> Nodemon, Testing Library, Babel</li>
        </ul>

        <p className="open-source-note">
          {t('each_library_respects_its_license', 'Each library is used under its respective license terms (MIT, ISC, Apache, etc.).')}
        </p>

        {/* ──────────────── */}
        {/* 🎨 VISUAL IDENTITY & DESIGN */}
        {/* ──────────────── */}
        <h2>{t('visual_identity_and_design', 'Visual Identity & Design')}</h2>

        <img
          src="/images/logo/isotype-positive.svg"
          alt="All-Voiced isotype (headphones)"
          style={{
            maxWidth: '90px',
            margin: '1rem auto 0.6rem auto',
            display: 'block',
            opacity: 0.9
          }}
        />

        <p style={{ textAlign: 'center', margin: '0.2rem 0' }}>
          <strong>{t('isotype_design', 'Isotype design')}:</strong>
        </p>

        <p style={{ textAlign: 'center', margin: '0.2rem 0' }}>
          Mariona Benito (2025)
        </p>

        <p style={{ textAlign: 'center', margin: '0.4rem 0 1.2rem 0' }}>
          <a
            href="https://www.linkedin.com/in/mariona-benito-calaf-481843356/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Mariona Benito on LinkedIn"
            style={{ display: 'inline-flex', alignItems: 'center' }}
          >
            <AVIcon icon="linkedin" width={16} height={16} />
          </a>
        </p>

        <p>
          {t(
            'logo_credit_intro',
            'The All-Voiced visual identity reflects the project’s commitment to listening, diversity, and scientific rigor.'
          )}
        </p>

        <p>
          {t(
            'isotype_note',
            'The headphones isotype was later integrated into the All-Voiced wordmark.'
          )}
        </p>

        <div className="credits-citations">
          <p>
            {t(
              'logo_rights_notice',
              'The All-Voiced visual identity and isotype are original works. All rights reserved. They may not be reproduced, modified, or used without prior written authorization.'
            )}
          </p>
        </div>


        {/* ──────────────── */}
        {/* 🪶 HOW TO CITE */}
        {/* ──────────────── */}
        <h2>{t("how_to_cite_all_voiced", "How to Cite All-Voiced")}</h2>
        <div className="citation-box">
          Calaf, Neus. ({currentYear}). <em>All-Voiced. </em><a href="https://www.all-voiced.com/" target="_blank" rel="noopener noreferrer">
            https://www.all-voiced.com/
          </a>
        </div>
      </div>
      <ScrollTracker pageName="CreditsAndCitations" />
    </div>
  );
}